import { render, staticRenderFns } from "./ParamOcupacao.vue?vue&type=template&id=ffbee408"
import script from "./ParamOcupacao.vue?vue&type=script&lang=js"
export * from "./ParamOcupacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports